export default "__VITE_ASSET__a62365a2__"